<div [ngStyle]="{'width': 400 + 'px'}" class="supp-selector-div">

  @if (params?.context?.isStockManager || !params?.data?._tags?.includes('disabled')) {
    <input
      #input
      (focus)="toggleDropdown()"
      [formControl]="searchControl"
      class="input"
      placeholder="Search Suppliers..."/>
  }

  <!--  <div (click)="toggleDropdown()" *ngIf="!params?.data?._tags?.includes('disabled')" class="toggle-button"> Options-->
  <!--    <app-icon-chevron-down></app-icon-chevron-down>-->
  <!--  </div>-->

  @if (showOptions) {
    <div #optionsList [ngClass]="{'options-list': true, 'above': displayAbove}">
      <div class="scrollable-options">
        @for (option of filteredOptions; track option.key) {
          <div>
            <label>
              <input
                (change)="toggleSelection(option.key)"
                [checked]="selectedValues.includes(option.key)"
                [disabled]="params.data?._tags?.includes('disabled') && !params.context?.isStockManager"
                type="checkbox"/>
              {{ option.key }} - {{ option.description }}
            </label>
          </div>
        }
      </div>
      <button (click)="onConfirmButtonClick()" class="buttons" type="button">OK</button>
      <button (click)="onCancelButtonClick()" class="buttons" type="button">Cancel</button>
    </div>
  }

  @if (params.data.originalValue[params.colDef.field].value !== value) {
    <app-display-icon
      (click)="onUndoChangesClick()"
      [icon]="icons.backSpaceOutline"
      class="backspace">
    </app-display-icon>
  }

</div>
